import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Table_permissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.table_permissions_Id,
          sortable: true,
          cell: (row) => <span>{row.table_permissions_Id}</span>,
        },
        { name: "Role Id", selector: (row, i) => row.role_id, sortable: true, cell: (row) => <span>{row.role_id}</span>, }, { name: "Table Name", selector: (row, i) => row.table_name, sortable: true, cell: (row) => <span>{row.table_name}</span>, }, { name: "Can Create", selector: (row, i) => row.can_create, sortable: true, cell: (row) => <span>{row.can_create}</span>, }, { name: "Can Read", selector: (row, i) => row.can_read, sortable: true, cell: (row) => <span>{row.can_read}</span>, }, { name: "Can Update", selector: (row, i) => row.can_update, sortable: true, cell: (row) => <span>{row.can_update}</span>, }, { name: "Can Delete", selector: (row, i) => row.can_delete, sortable: true, cell: (row) => <span>{row.can_delete}</span>, }, { name: "Can Export", selector: (row, i) => row.can_export, sortable: true, cell: (row) => <span>{row.can_export}</span>, }, { name: "Row Filter", selector: (row, i) => row.row_filter, sortable: true, cell: (row) => <span>{row.row_filter}</span>, }, { name: "Column Restrictions", selector: (row, i) => row.column_restrictions, sortable: true, cell: (row) => <span>{row.column_restrictions}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Table_permissionseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      table_permissions_Id: "",
      role_id: '', table_name: '', can_create: '', can_read: '', can_update: '', can_delete: '', can_export: '', row_filter: '', column_restrictions: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'role_id', inputType: 'Number', displayName: 'Role Id', validationOptions: { isRequired: false } },
      { fieldName: 'table_name', inputType: 'Text', displayName: 'Table Name', validationOptions: { isRequired: false } },
      { fieldName: 'can_create', inputType: 'Number', displayName: 'Can Create', validationOptions: { isRequired: false } },
      { fieldName: 'can_read', inputType: 'Number', displayName: 'Can Read', validationOptions: { isRequired: false } },
      { fieldName: 'can_update', inputType: 'Number', displayName: 'Can Update', validationOptions: { isRequired: false } },
      { fieldName: 'can_delete', inputType: 'Number', displayName: 'Can Delete', validationOptions: { isRequired: false } },
      { fieldName: 'can_export', inputType: 'Number', displayName: 'Can Export', validationOptions: { isRequired: false } },
      { fieldName: 'row_filter', inputType: 'Text', displayName: 'Row Filter', validationOptions: { isRequired: false } },
      { fieldName: 'column_restrictions', inputType: 'Text', displayName: 'Column Restrictions', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      role_id: '', table_name: '', can_create: '', can_read: '', can_update: '', can_delete: '', can_export: '', row_filter: '', column_restrictions: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      role_id: '', table_name: '', can_create: '', can_read: '', can_update: '', can_delete: '', can_export: '', row_filter: '', column_restrictions: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Table_permissionseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      table_permissions_Id: row.table_permissions_Id,
      role_id: row.role_id, table_name: row.table_name, can_create: row.can_create, can_read: row.can_read, can_update: row.can_update, can_delete: row.can_delete, can_export: row.can_export, row_filter: row.row_filter, column_restrictions: row.column_restrictions,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Table_permissionsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Table_permissions/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Table_permissionssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('role_id', this.state.role_id);
    formData.append('table_name', this.state.table_name);
    formData.append('can_create', this.state.can_create);
    formData.append('can_read', this.state.can_read);
    formData.append('can_update', this.state.can_update);
    formData.append('can_delete', this.state.can_delete);
    formData.append('can_export', this.state.can_export);
    formData.append('row_filter', this.state.row_filter);
    formData.append('column_restrictions', this.state.column_restrictions);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Table_permissions/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Table_permissionsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ role_id: '', table_name: '', can_create: '', can_read: '', can_update: '', can_delete: '', can_export: '', row_filter: '', column_restrictions: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Table_permissionsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("table_permissions_Id", this.state.table_permissions_Id);
    formData.append('role_id', this.state.role_id);
    formData.append('table_name', this.state.table_name);
    formData.append('can_create', this.state.can_create);
    formData.append('can_read', this.state.can_read);
    formData.append('can_update', this.state.can_update);
    formData.append('can_delete', this.state.can_delete);
    formData.append('can_export', this.state.can_export);
    formData.append('row_filter', this.state.row_filter);
    formData.append('column_restrictions', this.state.column_restrictions);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Table_permissions/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Table_permissionsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Table_permissionsfetchHandler();

    //***componentDidMount
  }

  handlerole_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ role_id: fieldValue });
  }; handletable_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ table_name: fieldValue });
  }; handlecan_createChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_create: fieldValue });
  }; handlecan_readChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_read: fieldValue });
  }; handlecan_updateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_update: fieldValue });
  }; handlecan_deleteChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_delete: fieldValue });
  }; handlecan_exportChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_export: fieldValue });
  }; handlerow_filterChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ row_filter: fieldValue });
  }; handlecolumn_restrictionsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ column_restrictions: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this table_permissions?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('table_permissions_Id', row.table_permissions_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Table_permissions/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Table_permissionsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Table Permissions</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Table_permissions</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Role Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlerole_idChange} className="form-control" name="role_id" value={this.state.role_id} required="required" placeholder="Enter Role Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.role_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Create</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_createChange} className="form-control" name="can_create" value={this.state.can_create} required="required" placeholder="Enter Can Create" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_create} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Read</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_readChange} className="form-control" name="can_read" value={this.state.can_read} required="required" placeholder="Enter Can Read" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_read} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Update</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_updateChange} className="form-control" name="can_update" value={this.state.can_update} required="required" placeholder="Enter Can Update" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_update} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Delete</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_deleteChange} className="form-control" name="can_delete" value={this.state.can_delete} required="required" placeholder="Enter Can Delete" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_delete} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Export</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_exportChange} className="form-control" name="can_export" value={this.state.can_export} required="required" placeholder="Enter Can Export" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_export} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Row Filter</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlerow_filterChange} className="form-control" name="row_filter" value={this.state.row_filter} required="required" placeholder="Enter Row Filter" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.row_filter} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Column Restrictions</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecolumn_restrictionsChange} className="form-control" name="column_restrictions" value={this.state.column_restrictions} required="required" placeholder="Enter Column Restrictions" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.column_restrictions} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Table_permissionssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Table_permissions</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Role Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlerole_idChange} className="form-control" name="role_id" value={this.state.role_id} required="required" placeholder="Enter Role Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.role_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Create</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_createChange} className="form-control" name="can_create" value={this.state.can_create} required="required" placeholder="Enter Can Create" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_create} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Read</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_readChange} className="form-control" name="can_read" value={this.state.can_read} required="required" placeholder="Enter Can Read" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_read} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Update</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_updateChange} className="form-control" name="can_update" value={this.state.can_update} required="required" placeholder="Enter Can Update" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_update} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Delete</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_deleteChange} className="form-control" name="can_delete" value={this.state.can_delete} required="required" placeholder="Enter Can Delete" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_delete} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Export</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_exportChange} className="form-control" name="can_export" value={this.state.can_export} required="required" placeholder="Enter Can Export" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_export} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Row Filter</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlerow_filterChange} className="form-control" name="row_filter" value={this.state.row_filter} required="required" placeholder="Enter Row Filter" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.row_filter} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Column Restrictions</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecolumn_restrictionsChange} className="form-control" name="column_restrictions" value={this.state.column_restrictions} required="required" placeholder="Enter Column Restrictions" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.column_restrictions} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Table_permissionsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}